import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import MyProfileService from '../services/MyProfileService'

import { DEFAULT_ROLE } from '../config/users'

import { AlertMsg, AlertError, AlertLoading } from '../helpers/AlertHelper'
import { Save2 } from 'react-bootstrap-icons'

const MyProfile = () => {

    const [name, setName] = useState('')
    const [vat, setVat] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [role, setRole] = useState(DEFAULT_ROLE)    
    const [formValid, setFormValid] = useState(false)
    const [showMsg, setShowMsg] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(false)

    const getData = async () => {
        await MyProfileService.getMyProfile().then(
            response => {
                setName(response.data.name || '')
                setVat(response.data.vat || '')
                setPhone(response.data.phone || '')
                setEmail(response.data.email || '')
                setRole(response.data.role || DEFAULT_ROLE)
                setIsLoaded(true)
            },
            error => {
                setError(error)
            })
    }

    useEffect(() => {

        getData()

    }, [])


    const handleInputChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        setFieldValue(name, value)
    }

    const setFieldValue = (fieldName, value) => {
        switch (fieldName) {
            case 'name':
                setName(value)
                break
            case 'vat':
                setVat(value)
                break
            case 'phone':
                setPhone(value)
                break
            case 'email':
                setEmail(value)
                break
            case 'password':
                setPassword(value)
                break
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        e.stopPropagation()

        const form = e.currentTarget
        if (!form.checkValidity()) {
            setFormValid(true)
            return
        }

        const user = {
            name,
            vat,
            phone,
            email
        }

        try {

            if (password.length !== 0) {
                user.password = password
            }
            await MyProfileService.updateMyProfile(user)

            setFormValid(false)

        } catch (error) {
            setShowMsg({ text: error || "An error occurred", style: 'danger' })
            setShowAlert(true)
        } finally {
            setFormValid(true)
        }
    }

    if (error) {
        return (
            <AlertError error={error} />
        )
    } else if (!isLoaded) {
        return (
            <AlertLoading isLoaded={isLoaded} />
        )
    }

    return (
        <Container className="p-5">
            <Form noValidate validated={formValid} onSubmit={handleSubmit}>


                <Form.Group className="mb-3" controlId="name">
                    <Form.Label><FormattedMessage id="usersName" defaultMessage="Name" />:</Form.Label>
                    <Form.Control
                        type="text"
                        name="name"
                        value={name}
                        onChange={handleInputChange}                        
                        required="required"
                    />
                    <Form.Control.Feedback type="invalid">
                        <FormattedMessage id="usersNameInvalid" defaultMessage="Provide an user name" />
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="vat">
                    <Form.Label><FormattedMessage id="usersVAT" defaultMessage="VAT number" />:</Form.Label>
                    <Form.Control
                        type="text"
                        name="vat"
                        value={vat}
                        onChange={handleInputChange}                        
                        required="required"
                    />
                    <Form.Control.Feedback type="invalid">
                        <FormattedMessage id="usersVATInvalid" defaultMessage="Provide a valid VAT number" />
                    </Form.Control.Feedback>
                </Form.Group>


                <Form.Group className="mb-3" controlId="role">
                    <Form.Label><FormattedMessage id="usersRole" defaultMessage="Role" />:</Form.Label>
                    <div className="mb-2">
                        {role}
                    </div>
                </Form.Group>


                <Form.Group className="mb-3" controlId="phone">
                    <Form.Label><FormattedMessage id="usersPhoneNumber" defaultMessage="Phone number" />:</Form.Label>
                    <Form.Control
                        type="text"
                        name="phone"
                        value={phone}
                        onChange={handleInputChange}                        
                        required="required"
                    />
                    <Form.Control.Feedback type="invalid">
                        <FormattedMessage id="usersPhoneNumberInvalid" defaultMessage="Provide a phone number" />
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="email">
                    <Form.Label><FormattedMessage id="usersEmail" defaultMessage="E-mail" />:</Form.Label>
                    <Form.Control
                        type="email"
                        name="email"
                        value={email}
                        onChange={handleInputChange}                        
                        required="required"
                        pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                    />
                    <Form.Control.Feedback type="invalid">
                        <FormattedMessage id="usersEmailInvalid" defaultMessage="Provide an Email address" />
                    </Form.Control.Feedback>
                </Form.Group>


                <Form.Group className="mb-3" controlId="password">
                    <Form.Label><FormattedMessage id="usersPassword" defaultMessage="Passworde" />:</Form.Label>
                    <Form.Control
                        type="password"
                        name="password"
                        value={password}
                        onChange={handleInputChange}                        
                    />
                    <Form.Control.Feedback type="invalid">
                        <FormattedMessage id="usersPasswordInvalid" defaultMessage="Provide an user password" />
                    </Form.Control.Feedback>
                </Form.Group>


                <AlertMsg message={showMsg.text} variant={showMsg.style} dismissible onCloseHandler={() => setShowAlert(false)} show={showAlert} />

                <div className="d-grid gap-2">


                    <Button
                        className="btn btn-primary"
                        type="submit"
                    >
                        <Save2 /> <FormattedMessage id="textSave" defaultMessage="Save" />
                    </Button>


                </div>
            </Form>
        </Container>
    )

}

export default MyProfile